import { useI18n } from "@/context/I18nContext";
import { TallyLines, lineTotals } from "@/components/TallyLines";

export const blankLine = (dc = "dr") => ({ dc, coa_id: "", ledger: "", amount: "", note: "" });

// API lines (debit / credit) -> editor lines (Dr/Cr + amount).
export const toEditLines = (lines) => lines.map((l) => {
  const d = Number(l.debit || 0);
  const c = Number(l.credit || 0);
  return { coa_id: l.coa_id, ledger: l.ledger || "", note: l.note || "", dc: c > 0 && !d ? "cr" : "dr", amount: String(d || c || "") };
});

export function journalTotals(lines) {
  const { td, tc } = lineTotals(lines);
  return { td, tc, balanced: Math.abs(td - tc) < 0.005 && td > 0 };
}

export const linesPayload = (lines) => lines.filter((l) => l.coa_id && Number(l.amount) > 0)
  .map((l) => ({ coa_id: l.coa_id, ledger: (l.ledger || "").trim(), note: (l.note || "").trim(), debit: l.dc === "dr" ? Number(l.amount) : 0, credit: l.dc === "cr" ? Number(l.amount) : 0 }));

// Tally-style: a new row takes the side and amount that balance the journal.
const balancingLine = (lines) => {
  const { td, tc } = lineTotals(lines);
  const diff = Math.round((td - tc) * 100) / 100;
  return { ...blankLine(diff > 0 ? "cr" : "dr"), amount: diff ? String(Math.abs(diff)) : "" };
};

// Shared double-entry editor (Jurnal Umum & Transaksi > Jurnal): Dr/Cr · Ledger · Account · Amount rows.
export function JournalLines({ clientId, coa, lines, onChange, testid = "journal" }) {
  const { t } = useI18n();
  const { balanced } = journalTotals(lines);
  return (
    <div className="space-y-2">
      <TallyLines clientId={clientId} coa={coa} lines={lines} onChange={onChange} newLine={balancingLine} minRows={2} testid={testid} />
      <p className={`text-xs ${balanced ? "text-emerald-600" : "text-rose-600"}`} data-testid={`${testid}-balance`}>{balanced ? t("jf.balanced") : t("jf.notBalanced")}</p>
    </div>
  );
}
